<div class="app-select-root m-0 relative w-full">
  <label *ngIf="label" [ngClass]="labelClass">
    {{ label }}
    <span *ngIf="required" class="text-red600">*</span>
  </label>

  <button
    #triggerButton
    type="button"
    [disabled]="isDisabled"
    [attr.aria-disabled]="isDisabled || isEmptyDisabled"
    (click)="toggle()"
    class="flex w-full items-center justify-between rounded-lg border border-slate300 px-3 text-left text-sm text-slate900 outline-none transition focus:border-indigo700"
    [ngClass]="triggerClassMap"
  >
    <span class="truncate" [ngClass]="[triggerTextSizeClass, selectedLabel ? 'text-slate900' : 'text-slate400']">
      {{ selectedLabel || placeholder }}
    </span>
    <span class="ml-3 inline-flex items-center text-slate600" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.235 6.49L7.53 9.59a.7.7 0 00.94 0l3.295-3.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </button>

  <div
    *ngIf="isOpen"
    [ngStyle]="menuStyle"
    class="fixed z-[999] mt-1 flex flex-col overflow-hidden rounded-lg border border-slate200 bg-white shadow-xl"
  >
    <ul *ngIf="hasOptions; else emptyState" class="max-h-60 overflow-y-auto py-1">
      <li *ngFor="let option of normalizedOptions">
        <button
          type="button"
          (click)="selectOption(option)"
          class="flex w-full items-center justify-between px-3 py-2 text-left text-sm transition hover:bg-indigo50"
          [ngClass]="isOptionSelected(option) ? 'bg-indigo50 text-indigo700' : 'text-slate700'"
        >
          <span class="truncate">{{ option.label }}</span>
          <span *ngIf="isOptionSelected(option)" class="ml-3 text-indigo600">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.4717 4.86142C12.7314 5.10794 12.7421 5.51887 12.4956 5.77854L7.1623 11.3976C7.04083 11.5256 6.87255 11.598 6.69614 11.598C6.51974 11.598 6.35145 11.5256 6.22999 11.3976L3.56332 8.58805C3.3168 8.32838 3.32746 7.91745 3.58713 7.67093C3.8468 7.42441 4.25773 7.43507 4.50425 7.69474L6.69614 10.0034L11.5545 4.88535C11.801 4.62568 12.2119 4.61501 12.4717 4.86142Z" fill="currentColor"/>
            </svg>
          </span>
        </button>
      </li>
    </ul>

    <ng-template #emptyState>
      <div class="px-3 py-3 text-sm text-slate500" role="status">
        {{ resolvedEmptyMessage }}
      </div>
    </ng-template>
  </div>

  <p class="mt-1 text-xs text-red600">
    {{ shouldShowError ? (error || fallbackError) : '' }}
  </p>
</div>
